import type NonEmptyText from '../non-empty-text';
import { assertIsInstanceOfNonEmptyText } from '../assertions';

interface IStore {
	readonly key: NonEmptyText;
}

export default class Store implements IStore {
	public get key(): NonEmptyText {
		return this.#key;
	}

	#key: NonEmptyText;
	public constructor({ key }: IStore) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
	}
}
